import React from 'react';

import PurchaseOrderShow from '@components/shared/purchaseOrders/PurchaseOrderShow';
import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import useCan from '@shared/permissions/useCan';
import { useOperatorPurchaseOrderService } from '@hooks/operator/purchase_orders/useOperatorPurchaseOrderService';
import warehouseService from '@services/operator/warehouseService';
import { useLoaderData } from 'react-router-dom';

export default function OperatorPurchaseOrderShow() {
  const data = useLoaderData();
  const { operator } = useOperatorAuth();
  const can = useCan();
  const purchaseOrderService = useOperatorPurchaseOrderService();

  return (
    <PurchaseOrderShow
      purchaseOrder={data}
      service={purchaseOrderService}
      warehouseService={warehouseService}
      role="operator"
      canApprove={can('purchase_orders:approve')}
      currentUserId={operator?.id}
    />
  );
}
